export default __webpack_public_path__ + "static/straight-5e97b42ca8385faa85b2a4e4da2d3290.png";